module.exports = __webpack_public_path__ + "static/media/Title.1d1f70a6.png";